import Vue from 'vue'
import store from '../store'
import Router from 'vue-router'


// 获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

let router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/pages/index'
    },
    {
      path: '*',
      name: '404',
      component: () => import('@/pages/404.vue')
    },
    {
      path: '/pages/login',
      name: 'pageLogin',
      menuName: '登录页面',
      component: () => import('@/pages/login.vue'),
      meta: {
        title: '登录页面'
      }
    },
    {
      path: '/pages/register',
      name: 'pageRegister',
      menuName: '注册页面',
      component: () => import('@/pages/register.vue'),
      meta: {
        title: '注册页面'
      }
    },
    {
      menuName: '前台页面',
      path: '/',
      component: () => import('@/pages/index.vue'),
      children: [

        {
          path: '/pages/meetingDetail',
          name: 'meetingDetailVue',
          menuName: '会议详情',
          component: () => import('@/pages/meetingDetail.vue'),
          meta: {
            title: '会议详情'
          }
        },
        {
          path: '/pages/index',
          name: 'pageIndexVue',
          menuName: '首页',
          component: () => import('@/pages/yiLiaoIndex.vue'),
          meta: {
            title: '首页'
          }
        },
        {
          path: '/pages/infoCenter',
          name: 'pageInfoCenter',
          menuName: '个人信息中心',
          component: () => import('@/pages/InfoCenter.vue'),
          meta: {
            title: '个人信息中心'
          }
        },
        {
          path: '/pages/applyInfoSave',
          name: 'applyInfoSave',
          menuName: '报名信息填写',
          component: () => import('@/pages/applyInfoSave.vue'),
          meta: {
            title: '报名信息填写'
          }
        }

      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  let token = localStorage.getItem('admin-token') || ''
  // console.log(to, from);

  if (to.meta.title) {
    document.title = to.meta.title
  }

  next()
})

Vue.use(Router)
export default router



// WEBPACK FOOTER //
// ./src/router/index.js